import tg_business from "./tg_business";
import activity from "./activity";
import member from "./member";
import accounts from "./accounts";
import game from "./game";
import pageConfig from "@/config/page";
const page = pageConfig.pages;

export default [
  {
    name: "home",
    path: "/",
    redirect: { name: "dashboard" },
    component: () => import("@/layout/routerView"),
    children: [
      {
        name: "dashboard",
        path: "dashboard",
        component: page.dashboard,
        meta: {
          title: "首頁",
        },
      },
      tg_business,
      activity,
      member,
      accounts,
      game,
      {
        name: "notice",
        path: "notice",
        component: page.notice,
      },
      {
        name: "online",
        path: "online",
        component: page.online,
      },
      {
        name: "assistence",
        path: "assistence",
        component: page.assistence,
      },
      {
        name: "service",
        path: "service",
        component: page.service,
      },
      {
        name: "rule",
        path: "rule",
        component: page.rule,
      },
      {
        name: "notOpen",
        path: "notOpen",
        component: page.notOpen,
      },
      {
        name: "ip_white",
        path: "ip_white",
        component: page.ip_white,
      },
    ],
  },
];
